import { ILearnTextTask } from 'common/modules/ReactShared';
import { FC } from 'react';

import LearnTaskTemplate from '../common/LearnTaskTemplate';
import { ILearnTaskProps } from '../types';

const LearnTextTask: FC<ILearnTaskProps<ILearnTextTask>> = ({
  task,
  onFinish,
  lightFont,
  isCompleting,
  previousTaskId
}) => {
  const {
    title,
    type,
    imageURL,
    mobileImageURL,
    coverImg,
    imageAlt,
    giphyImage,
    items: [{ content, audioURL }]
  } = task;

  return (
    <LearnTaskTemplate
      onFinish={onFinish}
      lightFont={lightFont}
      isCompleting={isCompleting}
      previousTaskId={previousTaskId}
      task={{
        title,
        audioURL,
        imageURL,
        mobileImageURL,
        coverImg,
        giphyImage,
        content,
        imageAlt,
        type
      }}
    />
  );
};

export default LearnTextTask;
